
import { defineComponent, ref, reactive, inject, onMounted } from "vue";
import { useRouter } from "vue-router";
import { defeatList } from "@/api/shenghuiHttp";
import { getCarBrand, getOrderCarSelectList } from "@/api/http";
import { column } from "@/assets/types/common";

const columnList: Array<column> = [
    { prop: "ordersn", label: "单据编号", width: 120 },
    { prop: "create_time", label: "开单时间", width: 80 },
    { prop: "meet_vehicle", label: "接车人", width: 80 },
    { prop: "orderstatustext", label: "状态", width: 70 },
    { prop: "progresstext", label: "进度", width: 60 },
    { prop: "order_offer_price", label: "报价", width: 80 },
    { prop: "order_advance_payment_text", label: "预收款", width: 80 },
    { prop: "car_code", label: "车牌号码", width: 90 },
    { prop: "category_name", label: "品牌车型", width: 80 },
    { prop: "user_id", label: "会员号", width: 80 },
    { prop: "send_for_repair", label: "送修人", width: 80 },
    { prop: "settlement_notes", label: "工单备注", width: 100 },
    { prop: "basicset_name", label: "服务类型", width: 80 },
    { prop: "shenghui_reason", label: "战败原因", width: 200 },
];

export default defineComponent({
    name: "DefeatedOrder",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["战败订单"]);
        const router = useRouter();

        const headClass = inject("headClass");
        const loading = ref(false);
        const tableData = ref([] as any[]);
        const total = ref(0);
        const pageSize = ref(10);
        const currentPage = ref(1);

        const selectGroup = reactive({
            date: null as any,
            project_type_id: "" as string | number,
            car_brand_id: "" as string | number,
            car_series_id: "" as string | number,
            search: "" as string,
        });
        const select = reactive({
            project_type_data: [] as any[],
            car_brand_data: [] as any[],
            car_series_data: [] as any[],
        });

        const brandChange = () => {
            selectGroup.car_series_id = "";
            if (selectGroup.car_brand_id) {
                getCarBrand({ brand_id: selectGroup.car_brand_id }).then((res: any) => {
                    select.car_series_data = res?.content?.list || [];
                });
            } else {
                select.car_series_data = [];
            }
            getTableData();
        };

        const getTableData = (): void => {
            loading.value = true;
            const data: any = {
                page: currentPage.value,
                limit: pageSize.value,
            };
            if (selectGroup.date && selectGroup.date.length === 2 && selectGroup.date[0] && selectGroup.date[1]) {
                data.date = [
                    `${selectGroup.date[0].getFullYear()}-${selectGroup.date[0].getMonth() + 1}-${selectGroup.date[0].getDate()}`,
                    `${selectGroup.date[1].getFullYear()}-${selectGroup.date[1].getMonth() + 1}-${selectGroup.date[1].getDate()}`,
                ];
            }
            if (selectGroup.project_type_id) data.project_type_id = selectGroup.project_type_id;
            if (selectGroup.car_brand_id) data.car_brand_id = selectGroup.car_brand_id;
            if (selectGroup.car_series_id) data.car_series_id = selectGroup.car_series_id;
            if (selectGroup.search) data.search = selectGroup.search;

            defeatList(data).then((res: any) => {
                const content = res?.content || {};
                tableData.value = content.list || [];
                total.value = content.total || 0;
                loading.value = false;
            }).catch(() => {
                loading.value = false;
            });
        };

        const handleSizeChange = (size: number) => { pageSize.value = size; currentPage.value = 1; getTableData(); };
        const handleCurrentChange = (page: number) => { currentPage.value = page; getTableData(); };

        const recoverOrder = (row: any) => {
            localStorage.setItem('order_id', row.id);
            router.push('/newCustomer/billingDetail');
        };

        onMounted(() => {
            getOrderCarSelectList().then((res: any) => {
                if (res.status == 200) {
                    select.project_type_data = res.content.project_type_data || [];
                }
            });
            getCarBrand({}).then((res: any) => {
                select.car_brand_data = res?.content?.list || [];
            });
            getTableData();
        });

        return {
            headClass, loading, tableData, total, pageSize, currentPage, columnList,
            selectGroup, select,
            getTableData, brandChange,
            handleSizeChange, handleCurrentChange,
            recoverOrder,
        };
    },
});
